<script>
    import { onMount } from 'svelte'
    export let src

    const requestURL = `https://vimeo.com/api/oembed.json?url=${src}?background=false&portrait=false&title=false&byline=false&responsive=true`
    const embed = !src
        ? { html: "<p class='noMedia'>No media has been uploaded to this project yet</p>" }
        : fetch(requestURL).then(res => res.json())
</script>

<div class="embed">
    {#await embed then embed}
        {@html embed.html}
    {/await}
</div>

<style lang="scss"></style>
